import { FIREBASE_ERROR_CODES, FirebaseLocale } from '../firebase/interfaces';
import { FirebaseError } from 'firebase/app';

const messages: { [key: string]: (loc: FirebaseLocale) => string } = {
  [FIREBASE_ERROR_CODES.AUTH_EMAIL_ALREADY_IN_USE]: (loc) => loc.emailInUse,
  [FIREBASE_ERROR_CODES.AUTH_INVALID_EMAIL]: (loc) => loc.invalidEmail,
  [FIREBASE_ERROR_CODES.AUTH_OPERATION_NOT_ALLOWED]: (loc) => loc.notAllowed,
  [FIREBASE_ERROR_CODES.AUTH_WEAK_PASSWORD]: (loc) => loc.weakPassword,
  [FIREBASE_ERROR_CODES.AUTH_INVALID_PHONE_NUMBER]: (loc) =>
    loc.invalidPhoneNumber,
  [FIREBASE_ERROR_CODES.AUTH_INVALID_VERIFICATION_CODE]: (loc) =>
    loc.invalidVerificationCode,
  [FIREBASE_ERROR_CODES.AUTH_MFA_INFO_NOT_FOUND]: (loc) => loc.mfaInfoNotFound,
  [FIREBASE_ERROR_CODES.AUTH_MFA_MISSING_CODE]: (loc) => loc.mfaCodeNotProvided,
  [FIREBASE_ERROR_CODES.AUTH_REQUIRES_RECENT_LOGIN]: (loc) =>
    loc.requiresRecentLogin,
  [FIREBASE_ERROR_CODES.AUTH_TOO_MANY_REQUESTS]: (loc) => loc.tooManyRequests,
  [FIREBASE_ERROR_CODES.AUTH_CAPTCHA_CHECK_FAILED]: (loc) =>
    loc.captchaCheckFailed,
  [FIREBASE_ERROR_CODES.AUTH_SECOND_FACTOR_ALREADY_IN_USE]: (loc) =>
    loc.phoneNumberAlreadyInUse,
  [FIREBASE_ERROR_CODES.AUTH_TOKEN_INVALID]: (loc) =>
    loc.mfaAuthUserTokenInvalid,
  [FIREBASE_ERROR_CODES.AUTH_SESSION_EXPIRED]: (loc) => loc.codeExpired,
};

export const getFirebaseLocalizedMsg = (
  error: FirebaseError,
  locale?: FirebaseLocale,
  defaultMsg?: string,
) => {
  if (!locale) return defaultMsg;

  return messages[error.code]?.(locale) || defaultMsg || locale?.defaultError;
};
